export default __webpack_public_path__ + "static/whiteTwitter-de2b5ecae6f4b911541eb0d4e24896f2.png";